import { render, staticRenderFns } from "./Scientific_boss.vue?vue&type=template&id=62526b4c&scoped=true"
import script from "./Scientific_boss.vue?vue&type=script&lang=js"
export * from "./Scientific_boss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62526b4c",
  null
  
)

export default component.exports